export default __webpack_public_path__ + "static/media/header.cafa89e8.png";